module.exports = __webpack_public_path__ + "static/media/condoms-OFF.8e3ff136.svg";